<script>
  import Timer from './Timer.svelte';
  import Sound from './Sound.svelte';
  import Goals from './Goals.svelte';

  let infoModal;

  function showInfo() {
    infoModal.showModal()
  }
  function hideInfo() {
    infoModal.close()
  }

</script>

<main>
  <div id="header">
    <h1>Pomodoro Tracker</h1>
    {#if IS_DEV}
    &nbsp;&nbsp;&nbsp;(dev)
    {/if}
    <ul>
      <li>
        <button on:click={showInfo}>What is it ?</button>
      </li>
    </ul>
  </div>

  <div style="display: flex; flex-direction: row; justify-content: center;">
    <div style="display: flex; flex-direction: column;">
      <Timer />
    </div>
    <div style="width:220px; display: flex; flex-direction: column;">
      <Goals />
      <Sound />
    </div>
  </div>

  <dialog
    bind:this={infoModal}
    scrollable="false">
    <div class="modal-container">
      <div class="content">
        <!-- Modal scrolls to the first focusable element on open so this link prevents
        scrolling to the bottom -->
        <a href=""></a>
        <h1>Pomodoro technique</h1>

        <h2>Description</h2>

        <p>
          The Pomodoro Technique is a powerful time management technique that
          can both help avoid procrastination and prevent burn-out. The way it works is very
          simple : choose a specific task and then start the timer and work on it for 25 minutes, with
          the exclusion of anything else. Then, take a 5 minutes break. Repeat that 3 more times for a
          total of 4 work periods, or "pomodoros". After 4 pomodoros, take a longer 15-30 minutes break.
          Then do a 4 pomodoro sequence again. This is your work for one day.
        </p>

        <h2>Work periods</h2>

        <p>
          The key to the effectiveness of the technique is that the 25 minutes work periods must
          be absolutely uninterrupted. That means no web browsing, no emails, no social media, no chat,
          no answering the phone,
          etc. If a pomodoro must be interrupted, then it must be invalidated. You can't pause
          a pomodoro and resume it later. This may seem too inflexible, but this is needed to
          fight procrastination. If a pomodoro were interrupted then an experienced procrastinator
          will find ways to postpone resuming the pomodoro indefinitely (I speak from experience).
          That is why I give no option to pause and resume a pomodoro. There are plenty Pomodoro
          apps out there that allow it but I think it is a mistake. One added benefit is that it
          penalizes procrastination tangibly and immediately, by not counting the last few minutes of
          work, reducing the incentive to stop working further.
        </p>

        <p>
          You can always cheat and let the timer run while doing something else, or skip breaks and
          do long stretches of work uninterrupted, but there is no competition here, no ranking of the
          "top performers of the month", nothing to win, no one to impress, so that is not necessary.
        </p>

        <p>
          The way procrastination usually works is that you have a hard time getting started but once that
          hurdle is passed you can work productively. The Pomodoro Technique helps pass that hurdle by
          making it a concrete and very low obstacle. All there is to do is click start, you already know
          what you need to do, you can start working right away. Also by keeping the work in short
          25 minute periods not a huge engagement is necessary to start. Usually, once the first pomodoro
          is finished you'll be carried in your work and want to do one more right away. It is important
          however to still take breaks regularly.
        </p>

        <h2>Breaks</h2>

        <p>
          The idea of a break is to prevent burn-out by giving a short period for your mind to rest.
          You should not do any intellectual activity during your break, but instead move away from the computer,
          do something physical which will get you up from your chair and get some blood flowing, simply
          having a short walk is fine, but you could also do a few stretching movements,
          push-ups, make yourself a cup of tea, etc. Not only will this help alleviate the health risks associated with
          sitting for long periods of time but it will also help creativity and prevent tunnel-vision phenomenons.
        </p>

        <p>The long breaks are less critical, they can be shorter or longer as needed, for example to accomodate for lunch.</p>

        <p>
          Breaks can also prevent burn-out in the longer term. Many people will fall into the trap
          of working until exhaustion for days and then need long periods to recover. Taking breaks will help you
          be more aware of your level of fatigue and stop for the day when you've expended your energy level and
          are not productive any more.
        </p>

        <h2>Questions and answers</h2>

        <h3>Why write this ? There are already multiple similar tools available.</h3>
        <p>
          What better way to procrastinate is there than to write a tool to combat procrastination ?
          That's basically how it all started. Later, I repurposed it as a learning tool for me to
          learn typescript and the Vue.js framework, and later yet Svelte.
        </p>

        <h3>How many pomodoros should I do per day ? Isn't 8 a low number ? That's only less than 4 hours per day !</h3>
        <p>
          I don't have a definitive answer to that question.
          By default I've set the daily goal to 8 pomodoros. Maybe you'll be able to do less, or maybe
          more, that's OK. Keep in mind that this is
          100% focused work, usually people don't work so focused, so it is much more draining. You'll
          probably find that you'll be able to work for less time that usual, but much more productively,
          so in the end you'll accomplish more work in less time !
        </p>
        <p>
          If you follow the recommended 25 minutes pomodoro / 5 minute breaks you'll be able to feel
          when you've reached your limit. If you feel too tired when you go on a break, and your
          productivity tanks, stop working for the day. That's also what makes breaks so important,
          by allowing you to feel the fatigue. If you find yourself dazed, unfocused, definitely
          stop working, it's better to do stop than to do low quality work, you can continue the next
          day when you're fresh.
        </p>

        <h3>Why is there no pause button ?</h3>
        <p>
          To be effective your Pomodoros should be 100% focused work. If it were possible to pause a
          Pomodoro then it would be too easy to get side-tracked reading mails, or generally
          procrastinating. If you need to pause, then cancel the Pomodoro and do a proper one later.
        </p>

        <h3>Where is my data stored ?</h3>
        <p>
          For now all data is stored in your browser's local storage. It means your goals are only
          counted in your current browser and won't show up if you access this site from a different one.
        </p>

        <h2>More questions, suggestions ?</h2>Contact me :
        <a
          href="mailto:contact@tomate.app?subject=[Pomodoro] "
        >contact@tomate.app</a>
      </div>
      <button id="close" on:click={hideInfo}>Close</button>
    </div>
  </dialog>
</main>

<style>
  #header {
    background: var(--primary-color);
    color: white;
    margin-bottom: 0.5em;
    position: relative;
  }
  #header h1 {
    margin: 0;
    padding: 0.3em 0 0.1em 62px;
    background: url("/tomate.png") no-repeat 10px center;
    display: inline-block;
  }
  #header ul {
    position: absolute;
    display: inline-block;
    top: 10%;
    height: 80%;
    right: 2px;
    margin: 0;
    padding: 0 0.2em;
  }
  #header li {
    list-style: none;
    display: inline-block;
    height: 100%;
  }
  /* #header li + li {
    border-left: 2px solid white;
  } */
  #header li button {
    background: transparent;
    border: none;
    border-radius: 6px;
    color: white;
    padding: 0 0.5em;
    margin-left: 5px;
    font-size: 120%;
    height: 100%;
  }
  #header li button:hover {
    background: rgba(255, 255, 255, 0.5);
  }

  dialog {
    padding: 0;
    border: 1px solid black;
    border-radius: 3px;
    text-align: justify;
    width: 80%;
    height: 80%;
  }
  dialog h1 {
    text-align: center;
    margin-top: 0.5em;
  }
  .modal-container {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .modal-container .content {
    flex: 1;
    overflow-y: auto;
    padding: 1em;
  }
  .modal-container button {
    background: var(--primary-color);
    border: none;
    border-top: 1px solid black;
    color: white;
    padding: 0.5em 0;
    font-size: 120%;
    width: 100%;
  }
  .modal-container button:hover {
    background: var(--primary-color-hover);
  }
</style>